//keyCode Shorthand
jQuery.keyCode = jQuery.ui.keyCode;